import _ from 'underscore';

import * as navigation from 'Navigation';
import {MODEL_NAMES} from 'results/ResultsNamingConstants';

class ResultStatusTabState extends navigation.TabState {
  override defaults(): navigation.TabStateDefaults {
    // eslint-disable-next-line no-restricted-syntax
    return _.extend(super.defaults(), {
      title: `${MODEL_NAMES.Result} Status`,
      closeable: false,
      options: false,
      preferenceKey: 'result-status',
    });
  }
}

export default ResultStatusTabState;
